import React from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/UI/Button';
import { dataAttrs } from 'Helpers/Testing';
import { DialogActions } from 'Views/Page/Content/Modal/Components';
import { FDPrimaryActionButton, FDSecondaryActionButton } from '@facet-wealth/design';
import Relationship from 'facet-rest/src/domain/Relationship';
import { noop } from 'lodash';

const AssetAndLiabilityDialogActions = ({
  addAnotherRel,
  handleSaveAndAddAnother,
  handleSaveAndClose,
  changeTypeRel,
  handleChangeType,
  isLoading,
  isDisabled,
  useFD,
}) => {
  if (useFD) {
    return (
      <DialogActions>
        {changeTypeRel && (
          <FDSecondaryActionButton
            onClick={handleChangeType}
            loading={isLoading}
            disabled={isDisabled}
            label={changeTypeRel.meta('prompt')}
            {...dataAttrs('change-type')}
          />
        )}
        {addAnotherRel && (
          <FDSecondaryActionButton
            onClick={() => handleSaveAndAddAnother(addAnotherRel)}
            loading={isLoading}
            disabled={isDisabled}
            label={addAnotherRel.meta('prompt')}
            {...dataAttrs('save-and-add-another-btn')}
          />
        )}
        <FDPrimaryActionButton
          loading={isLoading}
          onClick={handleSaveAndClose}
          disabled={isDisabled}
          label={'Save and close'}
          {...dataAttrs('save-and-close-btn')}
        />
      </DialogActions>
    );
  }


  return (
    <DialogActions>
      {changeTypeRel && (
        <Button
          round
          color="accentBlue20"
          disableElevation
          variant="contained"
          onClick={handleChangeType}
          isLoading={isLoading}
          disabled={isDisabled}
          {...dataAttrs('change-type')}
        >
          {changeTypeRel.meta('prompt')}
        </Button>
      )}
      {
        addAnotherRel ? (
          <Button
            round
            color="accentBlue20"
            disableElevation
            variant="contained"
            loading={isLoading}
            disabled={isDisabled}
            onClick={() => handleSaveAndAddAnother(addAnotherRel)}
            {...dataAttrs('save-and-add-another-btn')}
          >
            {addAnotherRel.meta('prompt')}
          </Button>
        ) : null
      }
      <Button
        round
        color="primary"
        disableElevation
        variant="contained"
        loading={isLoading}
        onClick={handleSaveAndClose}
        disabled={isDisabled}
        {...dataAttrs('save-and-close-btn')}
      >
        {'Save and close'}
      </Button>
    </DialogActions>
  );
};

AssetAndLiabilityDialogActions.defaultProps = {
  isLoading: false,
  isDisabled: false,
  changeTypeRel: undefined,
  handleChangeType: noop,
};

AssetAndLiabilityDialogActions.propTypes = {
  addAnotherRel: PropTypes.instanceOf(Relationship).isRequired,
  changeTypeRel: PropTypes.instanceOf(Relationship),
  handleChangeType: PropTypes.func,
  handleSaveAndAddAnother: PropTypes.func.isRequired,
  handleSaveAndClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  useFD: PropTypes.bool.isRequired,
};

export default AssetAndLiabilityDialogActions;
